import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    justify: 'space-between',
  },
  headerHeading: {
    fontSize: 'md',
    color: 'white',
    textTransform: 'capitalize',
  },
  headerIconButton: {
    color: 'beta.200',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {},
  headerVsBox: {
    px: '1',
  },

  bodyStack: {
    px: ['2.5', null, null, '3'],
    minH: '90vh',
  },
  bodyInnerWrapper: {},
  sgmLogo: {
    color: 'beta.500',
    h: '3',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    h: '9',
    variant: 'filter',
    boxShadow: 'none',
    w: 'full',
    sx: {
      'div:last-child': {
        maxH: '34px',
        button: {
          mt: '0',
        },
      },
    },
  },
  toMarketButton: {
    variant: 'unstyled',
    color: 'white',
    textTransform: 'uppercase',
    fontSize: '2xs',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: '#FF8A2F',
    fontWeight: 'bold',
    borderRadius: 'base',
    minW: ['auto', null, '10'],
    _hover: {
      color: '#FF8A2F',
    },
    sx: {
      '.btn-span': {
        px: '1',
        h: '21px',
      },
      '&[data-active], :active': {
        border: 'none',
        color: 'beta.800',
        bg: '#FF8A2F',
        h: '24px',
        '&:after': {
          display: 'none',
        },
      },
    },
    _last: { mr: 2 },
  },
  toMarketButtonV2: {
    minW: 'fit-content',
    px: '2',
    sx: {
      h: '100%',
      _hover: {
        color: 'beta.400',
      },
      '&[data-active]': {
        color: 'beta.400',
        fontWeight: 'bold',
        borderBottom: '3px solid',
        borderBottomColor: 'beta.400',
      },
    },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },

  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
    mt: '14px',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    textAlign: 'left',
    bgGradient: 'linear(to-b, gamma.400, gamma.500)',
    _expanded: {
      boxShadow:
        '0px -1px 0px 0px rgba(255, 255, 255, 0.20) inset, 0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    },
    _hover: {
      bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    color: 'alpha.600',
  },
  marketLayoutTooltip: {},
  marketLayoutIcon: {
    color: 'alpha.500',
    fontSize: 'lg',
  },
  marketLoadingCenter: {},
  centerLoadingSpinner: {},
  marketLayoutLoadedIcon: {},
  marketLayoutAccordionPanel: {
    bg: 'white',
    p: '0',
  },

  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'beta.500',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    variant: 'tab',
    flex: 1,
    position: 'relative',
    minH: '34px',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, alpha.200, alpha.400)',
    borderColor: 'beta.400',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow:
      '0px 2px 5px 0px rgba(0, 0, 0, 0.40), 0px 0px 0px 3px #003541 inset, 0px 0px 0px 5px rgba(0, 209, 255, 0.70) inset',
    sx: {
      svg: {
        color: 'white',
        fill: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'gamma.500',
        fill: 'gamma.500',
      },

      '&&': {
        bg: 'alpha.600',
        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.50) inset',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
